import { render, staticRenderFns } from "./MarketingBudgetOverTimeChart.vue?vue&type=template&id=ca61b95c"
import script from "./MarketingBudgetOverTimeChart.vue?vue&type=script&lang=js"
export * from "./MarketingBudgetOverTimeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports